module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_checkboxes-9e85d3d41c80bcb4724f92db76a0952f.jpg";